module.exports = "https://static.wanderu.com/ui-react/_next/static/media/ca.8d6232bb.svg";